import { axios } from "helper/axios";

const { PHCDashboardConstants } = require("./PHCDashboardConstants");

export const PHCDashboardApis = {};

PHCDashboardApis.getList = () => {
  return axios.get(PHCDashboardConstants.FETCH_PORTFOLIO_LIST_API);
};

PHCDashboardApis.crossSell = () => {
  return axios.post(PHCDashboardConstants.PHC_CROSS_SELL_API);
};

PHCDashboardApis.deletePortfolio = (id) => {
  return axios.delete(
    `${PHCDashboardConstants.PHC_PORTFOLIO_DELETE_API}/${id}`
  );
};
